import { useCallback } from 'react';

import type { Reference } from '@apollo/client';
import { Apollo } from 'src/gql/generated';

export function useDeleteApiKeys() {
  const [revokeApiKeys, { loading }] = Apollo.useRevokeApiKeysMutation();

  const deleteApiKeys = useCallback(
    (apiKeyIds: string[]) =>
      revokeApiKeys({
        update: (cache, { data }) => {
          if (!data?.revokeApiKeys) return;

          const deletedIds = new Set(data.revokeApiKeys);
          const apiKeysKey: keyof Apollo.Query = 'apiKeys';
          cache.modify({
            fields: {
              [apiKeysKey]: (refs: readonly Reference[] = [], { readField }) => {
                return refs.filter(ref => {
                  const apiKeyId = readField<string>('id', ref);
                  return apiKeyId && !deletedIds.has(apiKeyId);
                });
              },
            },
          });
          data.revokeApiKeys.forEach(apiKeyId => {
            cache.evict({ id: cache.identify({ __typename: 'ApiKey', id: apiKeyId }) });
          });
          cache.gc();
        },
        variables: { apiKeyIds },
      }),
    [revokeApiKeys]
  );

  return { deleteApiKeys, loading };
}
